function handleClickTracking(url) {
    fetch(url, {
        mode: 'no-cors',
    });
}
export default function injectStaticInstreamAdContent(divContainer, adContent) {
    const outdatedContent = divContainer.firstChild;
    if (outdatedContent) {
        divContainer.removeChild(outdatedContent);
    }
    const div = document.createElement('div');
    if (adContent.companionClickTracking) {
        div.onclick = () => handleClickTracking(adContent.companionClickTracking);
    }
    const instreamAdContent = `
    <a href="${adContent.companionClickThrough}" target="_blank" style="display: inline-block">
      <img src="${adContent.staticResource}" width="100%" />
    </a>
    <img style="width: 1px; height: 1px; visibility: hidden;" src="${adContent.trackingPixel}" />`;
    div.innerHTML = instreamAdContent;
    divContainer.appendChild(div);
    return div;
}
